import React from "react"

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { Link, graphql } from "gatsby"

import "swiper/components/navigation/navigation.scss"
import "swiper/components/pagination/pagination.scss"
import "swiper/components/scrollbar/scrollbar.scss"

// Import Swiper styles
import "swiper/swiper.scss"

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

const SwiperTest = () => {
  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      navigation
      loop={true}
      autoplay={{
        delay: 10000,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
      onSwiper={swiper => console.log(swiper)}
      onSlideChange={() => console.log("slide change")}
    >
      <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  />
                  <p className="">
                    I enjoy and value every conversation I have with Todd. He's
                    a deep thinker with great insights. I always walk away with
                    new ideas, new questions, and new answers. I like his
                    straight-talk style coupled with immense empathy. Todd's the
                    Real Deal.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">Frannie Matthews </h4>
                  <span className="text-muted">
                    CEO, Colorado Technology Association
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  />
                  <p className="">
                    A phenomenal asset to any business from an employee
                    perspective. I’ve appreciated Todd’s focus on culture within
                    a company, addressing and successfully aiding in resolving
                    aspects of a team/business that are often overlooked. He is
                    easy to speak with; open and honestly. Todd has inspired me
                    to think about ways to better myself - not only
                    professionally but personally. He reminds us of the
                    priorities of a work environment, always remembering the
                    humanity that is needed to keep the wheels spinning for the
                    employee and business alike.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">Kimberly Gonzalez</h4>
                  <span className="text-muted">
                    Office Manager, McAllister Garfield Law
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  />
                  <p className="">
                    [Todd] saved us countless hours of frustration and the
                    project thousands of dollars by helping us avoid dead ends
                    and accelerating our learning curve.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">John Minter</h4>
                  <span className="text-muted">CEO</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  />
                  <p className="">
                    I have streamlined my life and am very grateful for the
                    insight Todd Wheeler has given me. Some of the major
                    accomplishments I have been blessed to achieve since
                    implementing this process was buying my first home and
                    finishing my first novel. Mr. Wheeler's presentation helped
                    make it possible to keep all of the balls in the air, so to
                    speak.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">Ukela Alred</h4>
                  <span className="text-muted">CEO & Founder</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  />
                  <p className="">
                    Imagine your favorite sports team or athlete without a
                    coach. The results would likely not be great. The same goes
                    for business – why do you think most of them fail? Todd
                    Wheeler brings decades of business coaching to the table. If
                    you desire top performance amongst your leadership and team,
                    he needs to be your next call.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">Greg Frye</h4>
                  <span className="text-muted">Copy-Writer and Journalist</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  />
                  <p className="">
                    Our pr/ad agency has worked with Todd and his team for five
                    years now. He has helped us with everything from overall
                    strategy and operational alignment to business development
                    and executive leadership training. In the simplest of terms,
                    Todd just gets it. And that's the point. He is able to
                    approach complex situations, analyze them and offer
                    practical solutions that even a small family business like
                    ours can implement. He is a pleasure to work with and his
                    desire to help his clients succeed is as sincere as you ever
                    could dream of receiving from a consultant.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">David and Diane Eichler</h4>
                  <span className="text-muted">
                    Decibel Blue Advertising and PR
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      {/* <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  ></i>
                  <p className="">
                    I knew day one that Todd was an asset. His 'secret power' is
                    active listening. This allows him to assist in personal,
                    structural and organizational decisions from a place of
                    understanding. Todd taught me in the first week how to hook
                    "Difficult customers". I was shocked by how well his tactics
                    worked. He saved me so much time in meetings (which were the
                    majority of my headaches) and I learned how to get a signed
                    contract with a long commitment after only one in-person
                    meeting. Thank you Todd!
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">Jessica Kaiser</h4>
                  <span className="text-muted">CEO, Founder, Canna Demos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide> */}
      {/* <SwiperSlide>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 mx-auto">
            <div className="pt-0">
              <div className="review-item">
                <div className="review-statement">
                  <i
                    className="fa fa-quote-left"
                    style={{
                      fontSize: "35px",
                      paddingBottom: "25px",
                    }}
                  ></i>
                  <p className="">
                    Todd has assisted us with everything from determining what
                    area of focus we are going to hone in on, understanding the
                    psychology of how major corporations make decisions,
                    preparing sales presentations to meet clients’ needs, to
                    planning for the future growth of our business. The
                    information that we have gained has far exceeded our
                    expectations. After each consultation, we are amazed by the
                    amount of information that Todd has taught and provided us
                    within an hour session and the confidence that we have
                    gained through these sessions. Deciding to hire a consultant
                    was a tough decision for us, as we have very limited funds
                    as a start-up company...It is the best decision that we have
                    made to date.
                  </p>
                </div>
                <div className="pt-3">
                  <h4 className="mb-0 mt-3">Jennell Carter</h4>
                  <span className="text-muted">Founder</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide> */}
      <Link
        style={{ position: "relative", zIndex: "2" }}
        to="/reviews"
        className="hvr-bounce-to-right-reverse mt-3 btn-reverse"
      >
        Read More Reviews
      </Link>
    </Swiper>
  )
}

export default SwiperTest
